import { toCamelCaseDeep } from 'src/utils/transform';
import MemriseApi from '../MemriseApi';
import * as Types from './types';
import * as Schema from './schema';

export default class LearningQueueApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/me' });
  }

  public async getLearningQueue(languagePairId: number): Promise<Types.LearningQueueResponse> {
    const response = await this.get<Schema.LearningQueueResponse>(
      `/language_pairs/${languagePairId}/learning_queue/`,
    );
    return toCamelCaseDeep(response);
  }

  public async skipLearningQueueFeatures(
    languagePairId: number,
    featureTypes: Types.LearningFeatureType[],
    reason: 'user_preference' | 'all_words_marked_as_known' = 'user_preference',
  ): Promise<void> {
    await this.post(`/language_pairs/${languagePairId}/learning_queue/skip/`, {
      bodyObject: {
        learning_feature_types: featureTypes,
        reason,
      },
    });
  }
}

export const LearningQueueApi = new LearningQueueApiClass();
